<template>
    <main class="roles-page">
        <section class="roles-shell">
            <app-header btnHeading="" heading="Roles &amp; rights"
                subHeading="Control which features each user role can access." :isFormPage="true" @logout="logout"
                @show-drawer="showDrawer" />

            <!-- TABS -->
            <q-tabs v-model="activeRole" dense no-caps inline-label class="role-tabs" active-color="primary"
                indicator-color="primary" align="left">
                <q-tab v-for="role in roles" :key="role.key" :name="role.key" :label="role.name"
                    @click="GetRolesPermission(role.id)" />
            </q-tabs>

            <q-separator class="role-tabs-separator" />

            <!-- TAB PANELS -->
            <q-tab-panels v-model="activeRole" animated class="role-tab-panels">
                <q-tab-panel v-for="role in roles" :key="role.key" :name="role.key" class="role-tab-panel">
                    <section class="role-card">
                        <div class="role-card-header">
                            <div>
                                <h2>{{ role.name }}</h2>
                                <!-- <p class="role-meta">
                                    {{ role.description }}
                                    <span class="dot">·</span>
                                    {{ role.userCount }} {{ role.userCount === 1 ? 'user' : 'users' }}
                                </p> -->
                            </div>

                            <span v-if="role.isSystemRole" class="system-role-badge">System role</span>
                        </div>

                        <div class="permissions-grid">
                            <div v-for="group in role.groups" :key="group.key" class="permission-group">
                                <h3 class="group-title">{{ group.label }}</h3>

                                <label v-for="perm in group.items" :key="perm.key" class="permission-row"
                                    :class="{ 'is-checked': perm.checked }">
                                    <span class="custom-checkbox" :class="{ checked: perm.checked, custom_class_without_right : !userRole.manage }"
                                        @click="userRole.manage && togglePermission(role, perm)">
                                        <q-icon v-if="perm.checked" name="check" size="12px" />
                                    </span>
                                    <span class="permission-label" :class="{ custom_class_without_right : !userRole.manage }">{{ perm.label }}</span>
                                </label>
                            </div>
                        </div>

                        <div class="role-card-footer">
                            <q-btn :disable="!userRole.manage" no-caps unelevated label="Save permissions" icon="save" class="save-btn"
                                :loading="role.isSaving" @click="savePermissions(role)" />
                        </div>
                    </section>
                </q-tab-panel>
            </q-tab-panels>
        </section>
        <drawer ref="refDrawer" />
    </main>
</template>

<script>
    import axios from 'axios';
    import apis from '@/utilities';
    import header from '../components/header.vue';
    import Drawer from '../layout/drawer.vue';

    export default {
        name: 'RolesAndRights',
        components: {
            'app-header': header,
            Drawer,
        },

        data() {
            return {
                activeRole: 'SYSTEM_ADMIN',
                activeId: 1,
                roles: [],
                userRole:{}
            };
        },

        computed: {
            url() {
                return this.$store.getters.url;
            },
        },

        mounted() {
            this.getUserGroup();
            this.setUserRole();
        },

        methods: {
              setUserRole() {
            const {
                menu: { permissions },
            } = this.$store.state;

            if (permissions) {
                permissions?.map((m) => {
                    const accesstype = m.code?.split('.');
                    this.userRole[accesstype[accesstype?.length - 1]] = true;
                });
                console.log('userRole: ', this.userRole);
            }
        },
            // Har group ke sab possible permissions define karte hain, aur jo
            // is role ke liye "checked" hain unki keys upar `checkedKeys` mein aati hain.
            showDrawer() {
                if (this.$refs.refDrawer) {
                    this.$refs.refDrawer.toggleDrawer();
                }
            },
            logout() {
                sessionStorage.setItem('token', null);
                this.$store.commit('logOutHandler');
                // this.$router.push('/login');
            },

            async GetRolesPermission(id) {
                this.activeId = id ? id : this.activeId;
                try {
                    const response = await axios.get(`${this.url}/${apis.GetRolesPermission}?roleId=${this.activeId}`);
                    const {
                        data
                    } = response.data;
                    if (data.roleId) {
                        this.roles.map((role) => {
                            if (role.id == data.roleId) {
                                role.groups.map((group) => {
                                    group.items.map((itm) => {
                                        if (data.permissionId.includes(itm.id)) {
                                            itm.checked = true;
                                        }
                                    });
                                });
                            }
                        });
                    }
                } catch (err) {
                    this.$store.dispatch('triggerUnauthorizedError', err);
                    console.error(err);
                }
            },

            async getUserGroup() {
                try {
                    const response = await axios.get(`${this.url}/${apis.GetUserGroup}`);
                    const groups = response.data.data;
                    for (const i in groups) {
                        this.roles.push({
                            key: groups[i].code,
                            id: groups[i].id,
                            name: groups[i].name,
                            description: '',
                            userCount: 0,
                            isSystemRole: groups[i].isSystem,
                            isSaving: false,
                            groups: await this.buildGroups(),
                        });
                    }
                    this.GetRolesPermission(groups[0]?.id);

                } catch (err) {
                    this.$store.dispatch('triggerUnauthorizedError', err);
                    console.error(err);
                }
            },

            async buildGroups() {

                const response = await axios.get(`${this.url}/${apis.GetRolesPermissionList}`);
                const { data } = response.data;

                if (data) {
                    return data.map(dt => {
                        return {
                            key: dt.menuName,
                            label: dt.menuName,
                            items: dt.menuPermissions.map((groupKey) => ({
                                key: groupKey.code,
                                label: groupKey.name,
                                id: groupKey.id,
                                checked: false,
                            }))

                        }
                    });

                }
            },

            togglePermission(role, perm) {
                console.log('perm: ', perm);
                perm.checked = !perm.checked;
            },



            async savePermissions(role) {
                role.isSaving = true;

                const payload = {
                    roleId: role.id,
                    permissionId: role.groups.flatMap((group) => group.items.filter((item) => item.checked).map((item) => item.id)),
                };

                try {
                    await axios.post(`${this.url}/${apis.SaveRolesPermission}`, payload);
                    this.$q.notify({ type: 'positive', message: `Permissions saved for ${role.name}.`, position: 'top' });
                } catch (err) {
                    this.$store.dispatch('triggerUnauthorizedError', err);
                    console.error(err);
                    this.$q.notify({ type: 'negative', message: 'Unable to save permissions.', position: 'top' });
                } finally {
                    role.isSaving = false;
                }
            },

        },
    };
</script>

<style lang="scss" scoped>
@import '../../styles/quasar.scss';

.roles-page {
    min-height: 100vh;
    padding: 0;
    color: $primary;
    text-align: left;
}

.roles-shell {
    max-width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0;
}

/* ================= TABS ================= */

.role-tabs {
    margin: 0 18px;
    color: #73858a;
}

.role-tabs :deep(.q-tab) {
    padding: 0 14px;
    min-height: 44px;
    font-size: 13px;
    font-weight: 600;
}

.role-tabs :deep(.q-tab--active) {
    color: $primary;
}

.role-tabs-separator {
    margin: 0 18px 18px;
}

.role-tab-panels {
    background: transparent;
}

.role-tab-panel {
    padding: 0;
}

/* ================= ROLE CARD ================= */

.role-card {
    margin: 0 18px;
    padding: 20px 18px;
    background: #fff;
    border: 1px solid #e3ebed;
    border-radius: 12px;
}

.role-card-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 18px;
}

.role-card-header h2 {
    margin: 0;
    color: #1c2a2e;
    font-size: 20px;
    font-weight: 600;
}

.role-meta {
    margin: 4px 0 0;
    color: #73858a;
    font-size: 12px;
}

.role-meta .dot {
    margin: 0 4px;
    color: #c2cdd0;
}

.system-role-badge {
    flex: 0 0 auto;
    padding: 4px 10px;
    color: $primary;
    background: #e7f2f4;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 700;
    white-space: nowrap;
}

/* ================= PERMISSIONS GRID ================= */

.permissions-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0px;
}

.group-title {
    margin: 0 0 8px;
    color: #1c2a2e;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.02em;
}

/* ================= MODERN CHECKBOX ROW ================= */

.permission-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 8px;
    margin: 0 -8px;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.15s ease;
    user-select: none;
}

.permission-row:hover {
    background: #f4f8f9;
}

.permission-row.is-checked .permission-label {
    color: #1c2a2e;
    font-weight: 500;
}

.permission-label {
    color: #55757d;
    font-size: 13px;
    transition: color 0.15s ease;
}

.custom_class_without_right {
   opacity: 0.5;
}
.custom-checkbox {
    flex: 0 0 auto;
    width: 18px;
    height: 18px;
    display: grid;
    place-items: center;
    color: #fff;
    background: #fff;
    border: 1.5px solid #ccd8db;
    border-radius: 5px;
    transition: background 0.15s ease, border-color 0.15s ease, transform 0.1s ease;
}

.custom-checkbox.checked {
    background: $primary-gradient;
    border-color: transparent;
}

.permission-row:active .custom-checkbox {
    transform: scale(0.9);
}

/* ================= FOOTER ================= */

.role-card-footer {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
}

.save-btn {
    min-height: 40px;
    color: #fff;
    background: $primary-gradient;
    border-radius: 6px;
    font-size: 13px;
}

/* ============================================================
   TABLET (>= 641px)
   ============================================================ */

@media (min-width: 641px) {
    .roles-page {
        padding: 24px 16px;
    }

    .role-tabs {
        margin: 0;
    }

    .role-tabs-separator {
        margin: 0 0 20px;
    }

    .role-card {
        margin: 0;
        padding: 26px 30px;
    }

    .permissions-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 24px;
    }
}

/* ============================================================
   DESKTOP (>= 1024px)
   ============================================================ */

@media (min-width: 1024px) {
    .permissions-grid {
        grid-template-columns: repeat(5, minmax(0, 1fr));
    }
}

@media (min-width: 1201px) {
    .roles-shell {
        max-width: 80vw;
        margin: 0 auto;
    }
}
</style>